import axios from 'axios'
import { CATALOGO_ENDPOINT } from '../../../common/endpoints'

let inflight = null

/**
 * GET `${CATALOGO_ENDPOINT}/schema/` compartido entre `loadSchemasFromCatalogo` y `loadSchemasFromStock`,
 * que al iniciar la app disparan el mismo request en el mismo tick. Mientras hay uno en vuelo se reutiliza;
 * cada llamador recibe su propia copia de `data` para no compartir referencias mutables entre slices de redux.
 */
export function getCatalogSchema() {
  if (!inflight) {
    inflight = axios(`${CATALOGO_ENDPOINT}/schema/`)
    const clear = () => { inflight = null }
    inflight.then(clear, clear)
  }
  return inflight.then(res => ({ ...res, data: JSON.parse(JSON.stringify(res.data)) }))
}
